import React, { useEffect, useState, useRef } from "react";
import urls from "../Utils/urls";
import "../css/topup.css";
import "../css/hero.css";
import "../css/calculator.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

/* â"€â"€ Inline SVG icons â"€â"€ */
const IcoZap      = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IcoCheck    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoUsers    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoDollar   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>;
const IcoClock    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcoStar     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcoStarFill = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" strokeWidth="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcoStarEmpty= () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcoClipboard= () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>;
const IcoShield   = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>;
const IcoBell     = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
const IcoCreditCard=()=> <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IcoWallet   = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 12V8H6a2 2 0 0 1 0-4h14v4"/><path d="M4 6v12a2 2 0 0 0 2 2h14v-4"/><circle cx="16" cy="14" r="1" fill="currentColor"/></svg>;
const IcoActivity = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>;
const IcoGradCap  = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>;
const IcoPlane    = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19.5 2.5S18 2 16.5 3.5L13 7 4.8 5.2l-1.7 1.7 5.6 3.2-3.7 3.7H2l-1 2h3l2 2v3l2-1v-3.2l3.7-3.7 3.2 5.6z"/></svg>;
const IcoHome     = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IcoHeart    = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>;
const IcoMessageSq= () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoPhone    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcoMapPin   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const IcoMail     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IcoBank     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7"/></svg>;
const IcoChevDown = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>;
const IcoChevUp   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"/></svg>;

/* Counter animation hook */
function useCountUp(target, duration = 2000, started = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!started) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration, started]);
  return count;
}

/* Stat item with counter */
function StatItem({ icon, num, label, suffix, prefix, started, className = "" }) {
  const isDecimal = num % 1 !== 0;
  const intTarget = isDecimal ? Math.floor(num) : num;
  const count = useCountUp(intTarget, 2000, started);
  const display = isDecimal ? `${count}.${Math.round((num % 1) * 10)}` : count.toLocaleString('en-IN');
  return (
    <div className={`su-stat-item ${className}`}>
      <div className="su-stat-icon-wrap">{icon}</div>
      <div className="su-stat-num">{prefix}{display}{suffix}</div>
      <div className="su-stat-label">{label}</div>
    </div>
  );
}

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <div className={`su-faq-item ${open ? "open" : ""}`} onClick={() => setOpen(!open)}>
      <div className="su-faq-q">
        <span>{q}</span>
        <span className="su-faq-arrow">{open ? <IcoChevUp /> : <IcoChevDown />}</span>
      </div>
      {open && <div className="su-faq-a">{a}</div>}
    </div>
  );
};

const STEPS = [
  { num: "1", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>, title: "Apply Online", text: "Fill out our simple application form in less than 5 minutes." },
  { num: "2", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>, title: "Quick Verification", text: "Our automated system verifies your information instantly." },
  { num: "3", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>, title: "Receive Funds", text: "Money deposited directly to your bank account within minutes." },
];

// Sequence: num1 → line1 → num2 → line2 → num3
// Each step = 500ms apart
const STEP_SEQUENCE = [
  { type: 'num', idx: 0 },   // t=0:    badge 1 pops
  { type: 'line', idx: 0 },  // t=500:  line 1 draws
  { type: 'num', idx: 1 },   // t=1000: badge 2 pops
  { type: 'line', idx: 1 },  // t=1500: line 2 draws
  { type: 'num', idx: 2 },   // t=2000: badge 3 pops
];

function StepsSection() {
  const sectionRef = useRef(null);
  const [nums, setNums] = useState([false, false, false]);
  const [lines, setLines] = useState([false, false]);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        obs.disconnect();
        STEP_SEQUENCE.forEach((ev, i) => {
          setTimeout(() => {
            if (ev.type === 'num') {
              setNums(prev => { const n = [...prev]; n[ev.idx] = true; return n; });
            } else {
              setLines(prev => { const l = [...prev]; l[ev.idx] = true; return l; });
            }
          }, i * 500);
        });
      }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="su-steps-section" ref={sectionRef}>
      <div className="su-steps-inner">
        <div className="su-section-tag">PROCESS</div>
        <h2 className="su-steps-title">Get Loan in 3 Simple Steps</h2>
        <p className="su-steps-desc">
          No branch visits, no lengthy paperwork. Our fully digital process gets money in<br />
          <span>your account faster than you expect.</span>
        </p>

        <div className="su-steps-grid su-steps-grid-3">
          {/* Connector lines */}
          <div className={`su-step-connector su-step-connector--l ${lines[0] ? "su-step-connector--drawn" : ""}`} />
          <div className={`su-step-connector su-step-connector--r ${lines[1] ? "su-step-connector--drawn" : ""}`} />

          {STEPS.map((s, i) => (
            <div className="su-step-card su-step-card--active" key={i}>
              <div className="su-step-icon-wrap">
                <div className="su-step-icon">{s.icon}</div>
                <div className={`su-step-num ${nums[i] ? "su-step-num--pop" : ""}`}>{s.num}</div>
              </div>
              <h4 className="su-step-title">{s.title}</h4>
              <p className="su-step-text">{s.text}</p>
            </div>
          ))}
        </div>

        {/* CTA BAR */}
        <div className="su-steps-cta-bar">
          <div className="su-steps-cta-left">
            <h3>Ready to Get Started?</h3>
            <p>Apply in 5 minutes. Get money in hours.</p>
          </div>
          <Link to="/apply-now" className="su-steps-cta-btn">Apply Now &nbsp;→</Link>
        </div>
      </div>
    </section>
  );
}

const Home = () => {
  const [loanAmount, setLoanAmount] = useState(30000);
  const [loanDays, setLoanDays] = useState(15);
  const [dailyRate, setDailyRate] = useState(0.25);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [perView, setPerView] = useState(typeof window !== "undefined" && window.innerWidth <= 600 ? 1 : window.innerWidth <= 900 ? 2 : 3);
  const [statsStarted, setStatsStarted] = useState(false);
  const statsRef = useRef(null);

  const heroInterest = (loanAmount * dailyRate * loanDays) / 100;
  const heroProcessingFee = Math.round(loanAmount * 0.02);
  const heroTotal = Math.round(loanAmount + heroInterest + heroProcessingFee);
  const heroAmtPct = ((loanAmount - 5000) / (100000 - 5000)) * 100;
  const heroDaysPct = ((loanDays - 1) / (60 - 1)) * 100;
  const heroRatePct = ((dailyRate - 0.25) / (1 - 0.25)) * 100;

  const testimonials = [
    {
      name: "Rahul Sharma",
      text: "Salary Uncle saved me during an unexpected medical emergency. The process was incredibly smooth, and I had the money I needed in minutes.",
      role: "IT Professional, Bangalore"
    },
    {
      name: "Priya Patel",
      text: "I was skeptical at first, but the transparency and ease of using Salary Uncle won me over. No hidden charges as promised!",
      role: "Marketing Manager, Mumbai"
    },
    {
      name: "Akash Gupta",
      text: "The paperless process is a game-changer. Everything was done digitally, and I didn't have to visit any office or submit physical documents.",
      role: "Teacher, Delhi"
    }
  ];


  // âœ... Animate sections on scroll using IntersectionObserver
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.2 }
    );

    document
      .querySelectorAll(".feature-card, .step, .testimonial, .cta-content")
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Stats counter observer
  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setStatsStarted(true); obs.disconnect(); }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  // Responsive cards-per-view for testimonial slider
  useEffect(() => {
    const onResize = () => {
      const w = window.innerWidth;
      setPerView(w <= 600 ? 1 : w <= 900 ? 2 : 3);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Testimonial slider auto-advance (6 reviews total)
  useEffect(() => {
    const total = 6;
    const maxSlide = total - perView;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev >= maxSlide ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [perView]);

  return (
    <>
      <Helmet>
        <title>Apply for Instant salary Loan Online Now | Salary Uncle</title>
        <meta
          name="description"
          content="Get instant financial support with Salary Uncle online salary loan application. Apply now for quick approval, flexible terms, and convenient repayment options."
        />
        <link rel="canonical" href={`${urls.SITE_URL}/`} />
      </Helmet>

      {/* HERO SECTION */}
      <section className="su-hero">
        <div className="su-hero-inner">
          {/* LEFT TEXT */}
          <div className="su-hero-left">
            <h1 className="su-hero-title">
              Your Trusted<br />
              <span className="su-hero-title-green">Salary Uncle</span><br />
              <span className="su-hero-title-sub">For Every Financial Need</span>
            </h1>
            <p className="su-hero-desc">
              Experience hassle-free borrowing with our modern salary loans online platform — Get a salary loan in India instantly. Quick salary solution — your salary loan online in India made easy.
            </p>
            <div className="su-hero-buttons">
              <Link to="/apply-now" className="su-btn-primary">Apply Now &nbsp;→</Link>
              <Link to="/repay-loan" className="su-btn-outline-hero">Pay Now</Link>
            </div>

            {/* Quick trust strip */}
            <div className="su-hero-trust-strip">
              <div className="su-hero-trust-item">
                <div className="su-hero-trust-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6dd05a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                </div>
                <div>
                  <div className="su-hero-trust-num">10 Min</div>
                  <div className="su-hero-trust-label">Approval</div>
                </div>
              </div>
              <div className="su-hero-trust-item">
                <div className="su-hero-trust-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6dd05a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <div>
                  <div className="su-hero-trust-num">50K+</div>
                  <div className="su-hero-trust-label">Customers</div>
                </div>
              </div>
              <div className="su-hero-trust-item">
                <div className="su-hero-trust-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6dd05a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>
                </div>
                <div>
                  <div className="su-hero-trust-num">RBI</div>
                  <div className="su-hero-trust-label">Regulated</div>
                </div>
              </div>
              <div className="su-hero-trust-item">
                <div className="su-hero-trust-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" strokeWidth="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                </div>
                <div>
                  <div className="su-hero-trust-num">4.8/5</div>
                  <div className="su-hero-trust-label">Rating</div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT CARD -- Quick Loan Check */}
          <div className="su-hero-right">
            <div className="calc-card su-hero-calc">
              {/* Header */}
              <div className="calc-card-header">
                <div className="calc-card-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="12" y2="14"/></svg>
                </div>
                <div>
                  <div className="calc-card-title">Loan Calculator</div>
                  <div className="calc-card-sub">Salary loans · Short-term</div>
                </div>
              </div>

              {/* Amount */}
              <div className="calc-field">
                <div className="calc-field-top">
                  <span className="calc-field-name">Loan Amount</span>
                  <span className="calc-field-badge">₹{loanAmount.toLocaleString('en-IN')}</span>
                </div>
                <div className="calc-track-wrap">
                  <div className="calc-track-fill" style={{ width: `${heroAmtPct}%` }} />
                  <input type="range" className="calc-slider" min="5000" max="100000" step="1000"
                    value={loanAmount} onChange={e => setLoanAmount(Number(e.target.value))} />
                </div>
                <div className="calc-range-labels"><span>₹5,000</span><span>₹1,00,000</span></div>
              </div>

              {/* Days */}
              <div className="calc-field">
                <div className="calc-field-top">
                  <span className="calc-field-name">Loan Period</span>
                  <span className="calc-field-badge">{loanDays} Day{loanDays > 1 ? 's' : ''}</span>
                </div>
                <div className="calc-track-wrap">
                  <div className="calc-track-fill" style={{ width: `${heroDaysPct}%` }} />
                  <input type="range" className="calc-slider" min="1" max="60" step="1"
                    value={loanDays} onChange={e => setLoanDays(Number(e.target.value))} />
                </div>
                <div className="calc-range-labels"><span>1 Day</span><span>60 Days</span></div>
              </div>

              {/* Rate */}
              <div className="calc-field">
                <div className="calc-field-top">
                  <span className="calc-field-name">Interest Rate <span className="calc-field-hint">(per day)</span></span>
                  <span className="calc-field-badge">{dailyRate.toFixed(2)}%</span>
                </div>
                <div className="calc-track-wrap">
                  <div className="calc-track-fill" style={{ width: `${heroRatePct}%` }} />
                  <input type="range" className="calc-slider" min="0.25" max="1" step="0.25"
                    value={dailyRate} onChange={e => setDailyRate(Number(e.target.value))} />
                </div>
                <div className="calc-range-labels"><span>0.25%</span><span>0.50%</span><span>0.75%</span><span>1%</span></div>
              </div>

              {/* Summary */}
              <div className="calc-summary">
                <div className="calc-summary-item">
                  <div className="calc-summary-label">Principal</div>
                  <div className="calc-summary-val">₹{loanAmount.toLocaleString('en-IN')}</div>
                </div>
                <div className="calc-summary-sep" />
                <div className="calc-summary-item">
                  <div className="calc-summary-label">Interest</div>
                  <div className="calc-summary-val">₹{Math.round(heroInterest).toLocaleString('en-IN')}</div>
                </div>
                <div className="calc-summary-sep" />
                <div className="calc-summary-item">
                  <div className="calc-summary-label">Processing Fee</div>
                  <div className="calc-summary-val">2%</div>
                </div>
              </div>

              <div className="calc-total-row">
                <span>Total Repayment</span>
                <span className="calc-total-amt">₹{heroTotal.toLocaleString('en-IN')}</span>
              </div>

              <Link to="/apply-now" className="calc-apply-btn">
                Apply Now
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* TICKER BAR */}
      <div className="su-ticker-wrap">
        <div className="su-ticker-track">
          {(() => {
            const items = [
              { text: "Completely Paperless Process", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/></svg> },
              { text: "Quick Loan Disbursal", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> },
              { text: "Secure Digital Platform", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg> },
              { text: "Instant Financial Support", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3h12"/><path d="M6 8h12"/><path d="M6 13l8.5 8"/><path d="M6 13h3"/><path d="M9 13c6.667 0 6.667-10 0-10"/></svg> },
              { text: "Quick Eligibility Check", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg> },
            ];
            return [...items, ...items, ...items].map((t, i) => (
              <span key={i}>{t.icon} {t.text}</span>
            ));
          })()}
        </div>
      </div>

      {/* STATS BAR */}
      <div className="su-stats-bar" ref={statsRef}>
        <div className="su-stats-inner">
          <StatItem started={statsStarted} icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          } num={50000} suffix="+" label="Happy Customers" />
          <div className="su-stat-divider" />
          <StatItem started={statsStarted} icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3h12"/><path d="M6 8h12"/><path d="M6 13l8.5 8"/><path d="M6 13h3"/><path d="M9 13c6.667 0 6.667-10 0-10"/></svg>
          } num={500} prefix="₹" suffix=" Cr+" label="Loans Disbursed" />
          <div className="su-stat-divider su-stat-hide-mobile" />
          <StatItem started={statsStarted} className="su-stat-hide-mobile" icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          } num={4} suffix=" Hours" label="Avg. Disbursement" />
          <div className="su-stat-divider" />
          <StatItem started={statsStarted} icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          } num={4.8} suffix=" / 5" label="Customer Rating" />
        </div>
      </div>

      {/* WHY CHOOSE SALARY UNCLE */}
      <section className="su-why-section">
        <div className="su-why-inner">
          <div className="su-section-tag">WHY US</div>
          <h2 className="su-why-title">Why Choose Salary Uncle?</h2>
          <p className="su-why-desc">Instant loan approval made easy</p>
          <div className="su-why-grid">
            {[
              {
                to: "/why/tap-and-apply",
                accent: "#509540",
                badge: "01",
                icon: (
                  <svg className="su-why-svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2"/>
                    <circle cx="12" cy="17" r="1" fill="#509540" stroke="none"/>
                    <line x1="9" y1="6" x2="15" y2="6" className="su-why-svg-line"/>
                    <line x1="9" y1="10" x2="13" y2="10" className="su-why-svg-line2"/>
                  </svg>
                ),
                title: "Tap & Apply",
                desc: "Apply anytime, from anywhere — entirely from your phone in under 5 minutes.",
              },
              {
                to: "/why/minimal-documentation",
                accent: "#509540",
                badge: "02",
                icon: (
                  <svg className="su-why-svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="9" y1="13" x2="15" y2="13" className="su-why-svg-line"/>
                    <line x1="9" y1="17" x2="11" y2="17" className="su-why-svg-line2"/>
                  </svg>
                ),
                title: "Minimal Documentation",
                desc: "Just 3 documents. No stack of papers, no branch visits — quick and paperless.",
              },
              {
                to: "/why/trusted-and-verified",
                accent: "#509540",
                badge: "03",
                icon: (
                  <svg className="su-why-svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    <polyline points="9 12 11 14 15 10" className="su-why-svg-check"/>
                  </svg>
                ),
                title: "Trusted & Verified",
                desc: "RBI-registered NBFC with bank-grade encryption and full regulatory compliance.",
              },
              {
                to: "/why/customer-first",
                accent: "#509540",
                badge: "04",
                icon: (
                  <svg className="su-why-svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" className="su-why-svg-line"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" className="su-why-svg-line2"/>
                  </svg>
                ),
                title: "Customer-First Approach",
                desc: "Fast support, clear communication, and a team that truly puts you first.",
              },
            ].map((card, i) => (
              <Link to={card.to} className="su-why-card su-why-card-v2" key={i} style={{"--card-accent": card.accent}}>
                <div className="su-why-card-top">
                  <div className="su-why-icon-v2">{card.icon}</div>
                  <span className="su-why-badge">{card.badge}</span>
                </div>
                <h3 className="su-why-card-title">{card.title}</h3>
                <p className="su-why-card-desc">{card.desc}</p>
                <div className="su-why-learn">
                  Learn more
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 4 SIMPLE STEPS SECTION */}
      <StepsSection />


      {/* SALARY UNCLE ADVANTAGE */}
      <section className="su-adv-section">
        <div className="su-adv-inner">
          <div className="su-section-tag">WHY CHOOSE US</div>
          <h2 className="su-adv-title">The Salary Uncle Advantage</h2>
          <p className="su-adv-desc">We built SalaryUncle from the ground up with <strong>salaried professionals in mind</strong> -- faster, fairer, and friendlier than banks.</p>
          <div className="su-adv-grid">
            {[
              { icon: <IcoCheck />,      title: "Instant Approval",        desc: "AI-powered instant loan approvals in under 60 seconds.",      link: "/advantage/instant-approval" },
              { icon: <IcoShield />,     title: "Bank-Grade Security",     desc: "256-bit SSL encryption protects all your data.",              link: "/advantage/bank-grade-security" },
              { icon: <IcoActivity />,   title: "Lowest Interest Rates",   desc: "Starting at just 10.5% per annum -- no hidden charges.",      link: "/advantage/lowest-interest-rates" },
              { icon: <IcoClock />,      title: "Same Day Disbursement",   desc: "Loan credited to your account within 4 hours of approval.",   link: "/advantage/same-day-disbursement" },
              { icon: <IcoPhone />,      title: "Dedicated Support",       desc: "24/7 customer support via phone, chat, and WhatsApp.",        link: "/why/customer-first" },
              { icon: <IcoBank />,       title: "RBI Registered NBFC",     desc: "Fully regulated and compliant lending operations.",           link: "/about/rbi-regulated" },
              { icon: <IcoWallet />,     title: "No Collateral",           desc: "100% unsecured loans -- no assets required as security.",     link: "/advantage/no-collateral" },
              { icon: <IcoClipboard />,  title: "Minimal Documents",       desc: "Just salary slip + Aadhaar + PAN. That is all we need.",      link: "/why/minimal-documentation" },
            ].map((c, i) => (
              <Link to={c.link} className="su-adv-card" key={i}>
                <div className="su-adv-icon">{c.icon}</div>
                <h4 className="su-adv-card-title">{c.title}</h4>
                <p className="su-adv-card-desc">{c.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="su-testi-section">
        <div className="su-testi-inner">
          <div className="su-section-tag">TESTIMONIALS</div>
          <h2 className="su-testi-title">What Our Customers Say</h2>
          <p className="su-testi-desc">Real stories from real people whose <span>financial emergencies</span> we solved.</p>

          {(() => {
            const reviews = [
              { name:"Rajesh Kumar", role:"Software Engineer, Bangalore", amount:"₹80,000", stars:5, color:"#509540", text:"Got ₹80,000 in just 3 hours for my mother's surgery. Salary Uncle was a lifesaver. The process was completely online and team was very supportive." },
              { name:"Priya Sharma", role:"Marketing Manager, Delhi", amount:"₹75,000", stars:5, color:"#7c3aed", text:"Best loan experience ever! Unlike banks, there were no endless paperwork or multiple visits. Just uploaded my documents and money was in account next morning." },
              { name:"Amit Patel", role:"CA, Mumbai", amount:"₹90,000", stars:5, color:"#d97706", text:"Transparent fees, no hidden charges, and the interest rate was competitive. I have recommended Salary Uncle to at least 20 of my colleagues." },
              { name:"Sunita Rao", role:"Teacher, Hyderabad", amount:"₹70,000", stars:4, color:"#059669", text:"Needed urgent funds for my daughter's engineering college fees. Applied at 10 PM, approval by midnight, and money credited by 8 AM next day. Amazing!" },
              { name:"Vikram Singh", role:"Bank Officer, Chandigarh", amount:"₹1,00,000", stars:5, color:"#7c3aed", text:"I work in banking but still chose Salary Uncle for personal loan because their digital process is far superior and approval time is unmatched." },
              { name:"Meena Joshi", role:"HR Executive, Pune", amount:"₹1 Lakh", stars:5, color:"#d97706", text:"Used travel loan for my honeymoon trip. Minimal documentation, fast disbursal, and the EMI was very manageable. Highly recommend!" },
            ];
            const maxSlide = reviews.length - perView;
            const safeSlide = Math.min(currentSlide, maxSlide);
            return (
              <div className="su-testi-slider-wrap">
                <div className="su-testi-viewport">
                  <div className="su-testi-track" style={{ "--slide": safeSlide }}>
                    {reviews.map((t, i) => (
                      <div className="su-testi-card" key={i}>
                        <div className="su-testi-top">
                          <div className="su-testi-avatar" style={{ background: t.color }}>{t.name.charAt(0)}</div>
                          <div className="su-testi-meta">
                            <div className="su-testi-name">{t.name}</div>
                            <div className="su-testi-role">{t.role}</div>
                          </div>
                          <div className="su-testi-amount">{t.amount}</div>
                        </div>
                        <div className="su-testi-stars">
                          {Array.from({length: t.stars}).map((_,j) => <IcoStarFill key={j} />)}
                          {Array.from({length: 5 - t.stars}).map((_,j) => <IcoStarEmpty key={j} />)}
                        </div>
                        <p className="su-testi-text">"{t.text}"</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Dots */}
                <div className="su-testi-dots">
                  {Array.from({ length: maxSlide + 1 }).map((_, i) => (
                    <button
                      key={i}
                      className={`su-testi-dot ${currentSlide === i ? "su-testi-dot--active" : ""}`}
                      onClick={() => setCurrentSlide(i)}
                      aria-label={`Slide ${i + 1}`}
                    />
                  ))}
                </div>
              </div>
            );
          })()}
        </div>
      </section>

      {/* FAQ */}
      <section className="su-faq-section">
        <div className="su-faq-inner">
          <div className="su-section-tag">FAQ</div>
          <h2 className="su-faq-title">Frequently Asked Questions</h2>
          <p className="su-faq-desc">Got questions? We have answers.</p>
          <div className="su-faq-list">
            {[
              { q:"What is Salary Uncle?", a:"Salary Uncle is a short-term, unsecured loan offered by Non-Banking Financial Companies (NBFCs) to help individuals meet immediate financial needs." },
              { q:"How do Salary Uncle work?", a:"Salary Uncle are usually small amounts of money, offered without the need for collateral." },
              { q:"What is the eligibility to apply for a Loan?", a:"Eligibility criteria is You must be at least 21 years of age. You should be a salaried employee or have a steady source of income." },
              { q:"How much can I borrow through a Salary Uncle Loan?", a:"The loan amount typically ranges from ₹5,000 to ₹1,00,000, depending on your income, credit score, and the lending policies." },
              { q:"What is the repayment period for a Salary Uncle Loan?", a:"Repayment terms generally range from 7 days to 30 days, often aligning with your payday." },
              { q:"Do I need to provide collateral to get a Salary Uncle Loan?", a:"No, payday loans are typically unsecured, meaning no collateral is required." },
            ].map((item, i) => (
              <FaqItem key={i} q={item.q} a={item.a} />
            ))}
          </div>
        </div>
      </section>

      {/* BOTTOM CTA BANNER */}
      <section className="su-bottom-cta">
        <div className="su-bottom-cta-inner">
          <h2>Need Money Today? We Can Help.</h2>
          <p>Join 50,000+ salaried professionals who trust <strong>Salary Uncle</strong> for their financial needs.</p>
          <div className="su-bottom-cta-btns">
            <Link to="/apply-now" className="su-bcta-primary">Apply Now</Link>
            {/* <a href="tel:+918796041166" className="su-bcta-outline"><IcoPhone /> Call: +91 87960 41166</a> */}
            {/* <a href="tel:+917428966221" className="su-bcta-outline"><IcoPhone /> Call: +91 7428966221</a> */}
            <a href="tel:+917042561004" className="su-bcta-outline"><IcoPhone /> Call: +91 7042561004</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;